import * as constants from "../consts";

const AmountRegex = /^[0-9]*$/g;

export const validateAmountInput1 = (oldValue, newValue) => {
  if (
    newValue.split("").filter((i) => i !== "." && isNaN(parseInt(i))).length > 0
  ) {
    return oldValue;
  }
  let decimalSections = newValue.split(".");
  if (decimalSections.length > 2) {
    return oldValue;
  }
  if (decimalSections.length === 2 && decimalSections[1].length > 2) {
    //only allow two decimal places
    return oldValue;
  }
  return newValue;
};

//TODO improve
export const validateAmountInput = (oldValue, newValue) => {
  //console.log("hue validateAmountInput", oldValue, newValue);
  newValue = newValue.replaceAll(".", "");
  newValue = newValue.replaceAll(" ", "");
  newValue = newValue.replaceAll(",", "");

  if (newValue.split("").filter((i) => isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }

  if (newValue.length === 1) {
    //console.log("hue validateAmountInput 1", newValue);
    return `0.0${newValue}`;
  } else {
    //console.log("hue validateAmountInput 2", newValue);
    let tokens = newValue.split("");
    let temp = [];
    for (let x = 0; x < tokens.length; x++) {
      if (x === tokens.length - 2) {
        temp.push(".");
        temp.push(tokens[x]);
      } else {
        temp.push(tokens[x]);
      }
      //console.log("hue validateAmountInput 3", temp);
    }
    //console.log("hue validateAmountInput 4", temp);

    let toldValue = oldValue.replaceAll(",", "");
    let tt = parseFloat(temp.join(""));
    //console.log("hue validateAmountInput 5", tt, parseFloat(toldValue))
    if (tt < parseFloat(toldValue) && tt < 1.0) {
      //console.log("hue validateAmountInput 6", "DANG")
      return "";
    }

    let isCheckForZero = true;
    let newVal = "";

    for (let x = 0; x < temp.length; x++) {
      let item = temp[x];
      if (item === ".") {
        newVal += item;
      } else {
        if (isCheckForZero) {
          if (item === 0) {
            //dont add
          } else {
            isCheckForZero = false;
            newVal += item;
          }
        } else {
          newVal += item;
        }
      }
    }

    //newVal = formatCurrency(newVal); //TODO change may be?
    let testVal = newVal.replaceAll(",", "");
    if (isNaN(parseFloat(testVal))) {
      return oldValue;
    }

    return newVal;
  }

  return newValue;
};

export const sanitizeAmountInput = (input) => {
  return input.replaceAll(",", "");
};

export const validateCardOrAccountNumber = (oldValue, newValue) => {
  newValue = newValue.replaceAll(/\s/g, "");
  if (newValue.split("").filter((i) => isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }
  return newValue;
};

export const validateAccountNumber = (oldValue, newValue) => {
  newValue = newValue.replaceAll(/\s/g, "");
  if (newValue.split("").filter((i) => isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }
  if (newValue.length > 12) return oldValue;
  return newValue;
};

export const validateCardNumber = (oldValue, newValue) => {
  newValue = newValue.replaceAll(/\s/g, "");
  if (newValue.split("").filter((i) => isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }
  if (newValue.startsWith("5366") && newValue.length > 15) {
    return oldValue;
  } else if (newValue.length > 16) {
    return oldValue;
  }
  return newValue;
};

export const validateAlphaNumeric = (oldValue, newValue) => {
  if (!/[^a-zA-Z0-9 ]/.test(newValue)) {
    return newValue;
  }
  return oldValue;
};

export const validateAlphaNumericWithoutSpace = (oldValue, newValue) => {
  if (!/[^a-zA-Z0-9]/.test(newValue)) {
    return newValue.toUpperCase();
  }
  return oldValue;
};

export const validateAlphaNumeric30Chars = (oldValue, newValue) => {
  if (!/[^a-zA-Z0-9 ]/.test(newValue) && newValue.length <= 30) {
    if (newValue === " ") {
      return "";
    }
    return newValue;
  }
  return oldValue;
};

export const validateNickName = (oldValue, newValue) => {
  if (!/[^a-zA-Z0-9 ]/.test(newValue) && newValue.length <= 20) {
    if (newValue === " ") {
      return "";
    }
    return newValue;
  }
  return oldValue;
};

export const validateLetters = (oldValue, newValue) => {
  if (/[^a-zA-Z ]/.test(newValue)) {
    return oldValue;
  }
  return newValue;
};

export const validateUserPassword = (password) => {
  const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  let res = {
    status: false,
    hasCharCount: password.length >= 8,
    hasLower: password.toUpperCase() !== password,
    hasUpper: password.toLowerCase() !== password,
    hasNumbers: /\d/.test(password),
    hasSpecial: format.test(password),
  };
  res.status =
    res.hasLower &&
    res.hasUpper &&
    res.hasNumbers &&
    res.hasCharCount &&
    res.hasSpecial;
  return res;
};

export const validateNIC = (oldValue, newValue) => {
  if (/[^vxVX0-9]/.test(newValue)) {
    return oldValue;
  }
  let withoutNumbers = newValue.replace(/\d+/g, "");
  if (withoutNumbers.length > 1) {
    return oldValue;
  }
  if (
    withoutNumbers.length === 1 &&
    !isNaN(parseInt(newValue[newValue.length - 1]))
  ) {
    return oldValue;
  }
  return newValue.toUpperCase();
};

export const validateCvv = (oldValue, newValue) => {
  if (/[^X0-9]/.test(newValue)) {
    return oldValue;
  }
  if (newValue.length > 4) {
    return oldValue;
  }
  return newValue;
};

export const validateCharLength = (oldValue, newValue, length) => {
  if (newValue.length > length) return oldValue;
  return newValue;
};

export const formatCurrency = (num, currency) => {
  if (!currency) {
    currency = constants.DEF_CURRENCY;
  }
  let options = { style: "currency", currency: currency };
  const formatter = new Intl.NumberFormat("en-US", options);
  return formatter.format(num).replace(`${currency}`, "");
};
